import { render, staticRenderFns } from "./BlowSegments.vue?vue&type=template&id=484380c8&scoped=true&"
import script from "./BlowSegments.vue?vue&type=script&lang=ts&"
export * from "./BlowSegments.vue?vue&type=script&lang=ts&"
import style0 from "./BlowSegments.vue?vue&type=style&index=0&id=484380c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484380c8",
  null
  
)

export default component.exports